const tooltipLabelMarker = 'data-tip-label'

const operableTags = ['BUTTON', 'INPUT', 'SELECT', 'TEXTAREA']

const operableRoles = [
  'button',
  'checkbox',
  'combobox',
  'link',
  'menuitem',
  'menuitemcheckbox',
  'menuitemradio',
  'option',
  'radio',
  'slider',
  'spinbutton',
  'switch',
  'tab',
  'textbox',
]

function plainText(html: string): string {
  const template = document.createElement('template')
  const parts: string[] = []

  template.innerHTML = html

  const walker = document.createTreeWalker(template.content, NodeFilter.SHOW_TEXT)

  while (walker.nextNode()) parts.push(walker.currentNode.textContent ?? '')

  return parts.join(' ').replace(/\s+/g, ' ').trim()
}

function isOperable(el: HTMLElement): boolean {
  return (
    operableTags.includes(el.tagName) ||
    operableRoles.includes(el.getAttribute('role') ?? '') ||
    (el.tagName === 'A' && el.hasAttribute('href'))
  )
}

export function syncTooltipLabel(el: HTMLElement, tooltip: unknown) {
  const current = el.getAttribute('aria-label')
  const written = el.getAttribute(tooltipLabelMarker)

  if (current !== null && current !== written) {
    el.removeAttribute(tooltipLabelMarker)

    return
  }

  const label = typeof tooltip === 'string' && isOperable(el) && !el.textContent?.trim() ? plainText(tooltip) : ''

  if (label) {
    el.setAttribute('aria-label', label)
    el.setAttribute(tooltipLabelMarker, label)

    return
  }

  if (written === null) return

  el.removeAttribute('aria-label')
  el.removeAttribute(tooltipLabelMarker)
}
